import { isNil } from 'lodash-es'
import { action, computed, observable } from 'mobx'

import { DialogService } from './internal/DialogService'
import { PageLoaderService } from './internal/PageLoaderService'
import { SnackService } from './internal/SnackService'

export interface PurchaseOrders {
  pageVersion: number
}

interface UIStoreSavedSettings {
  leftPanel: boolean
  purchaseOrders: PurchaseOrders
}

export class UIStore {
  static readonly defaultSettings: UIStoreSavedSettings = {
    leftPanel: true,
    purchaseOrders: {
      pageVersion: 0,
    },
  }
  readonly savedSettingsKey = 'ui-settings'
  readonly tabletWidthBreakpoint = 767
  readonly phoneWidthBreakpoint = 480
  readonly pageVersionPOM = 1

  @observable
  leftPanel: boolean
  @observable
  searchDialog = false
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'isTabletResolution' has no initializer a... Remove this comment to see the full error message
  isTabletResolution: boolean
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'isPhoneResolution' has no initializer an... Remove this comment to see the full error message
  isPhoneResolution: boolean
  @observable
  purchaseOrders: PurchaseOrders

  loader: PageLoaderService
  dialog: DialogService
  snack: SnackService

  constructor() {
    const { savedSettings } = this
    this.leftPanel = savedSettings.leftPanel
    this.purchaseOrders = { ...savedSettings.purchaseOrders }

    this.loader = new PageLoaderService()
    this.dialog = new DialogService()
    this.snack = new SnackService()

    this.checkIfResolutionIsMobile()

    // @ts-expect-error TS(2565) FIXME: Property 'isTabletResolution' is used before being... Remove this comment to see the full error message
    if (this.isTabletResolution || this.isPhoneResolution) {
      // Always start with the side menu closed on mobile
      this.leftPanel = false
    }
  }

  @computed
  get savedSettings(): UIStoreSavedSettings {
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      const savedSettings: UIStoreSavedSettings = JSON.parse(localStorage.getItem(this.savedSettingsKey))
      const { defaultSettings } = UIStore

      return {
        leftPanel: isNil(savedSettings.leftPanel) ? defaultSettings.leftPanel : savedSettings.leftPanel,
        purchaseOrders: { ...defaultSettings.purchaseOrders, ...savedSettings.purchaseOrders },
      }
    } catch (ignoreError) {
      return UIStore.defaultSettings
    }
  }

  set savedSettings(newSettings: UIStoreSavedSettings) {
    localStorage.setItem(this.savedSettingsKey, JSON.stringify(newSettings))
  }

  /**
   * Updates only the settings given
   *
   * @param newValues Object with the properties to be updated
   */
  updateSettings = (newValues: Partial<UIStoreSavedSettings>) => {
    this.savedSettings = { ...this.savedSettings, ...newValues }
  }

  @action
  checkIfResolutionIsMobile = () => {
    this.isTabletResolution = window.innerWidth <= this.tabletWidthBreakpoint
    this.isPhoneResolution = window.innerWidth <= this.phoneWidthBreakpoint
  }

  @action
  toggleLeftPanel = () => {
    this.leftPanel = !this.leftPanel
    this.updateSettings({ leftPanel: this.leftPanel })
  }

  @action
  openLeftPanel = () => {
    if (this.leftPanel) {
      return
    }
    this.leftPanel = true
    this.updateSettings({ leftPanel: true })
  }

  @action
  closeLeftPanel = () => {
    if (!this.leftPanel) {
      return
    }
    this.leftPanel = false
    this.updateSettings({ leftPanel: false })
  }

  @action
  toggleSearchDialog = () => {
    this.searchDialog = !this.searchDialog
  }

  @action
  setPurchaseOrdersPageVisited = () => {
    this.purchaseOrders.pageVersion = this.pageVersionPOM
    this.updateSettings({ purchaseOrders: this.purchaseOrders })
  }
}
